export default __webpack_public_path__ + "static/media/mandala_one.41d0e057.png";